import { ServerModelWithDateStrings } from "@teamprevent/common/utils";

export interface AuditLogEntryDto {
    eventType: string;
    actionType: string | null;
    timeGenerated: Date;
    before: object | null;
    after: object | null;
    user: object | null;
}

export const parseAuditLogsModel = (model: ServerModelWithDateStrings<AuditLogEntryDto>): AuditLogEntryDto => {
    return {
        ...model,
        timeGenerated: new Date(model.timeGenerated)
    };
};
